import { Body, H6, Stack } from '@qred/components-library';
import React, { Fragment } from 'react';
import useTranslate from '~/hooks/useTranslate';
import {
  IconWrapper,
  ItemWrapper,
  Line,
  Container,
} from './VerticalTimeline.styled';
import { useUpdateApplicationSelectors } from '~/store/selectors/updateApplication/updateApplication.selector';
import Icon from './components/Icon';
import StepGroup from './components/StepGroup';

export const VerticalTimeline = () => {
  const { allSteps } = useUpdateApplicationSelectors();
  const t = useTranslate();
  const completedIndex = 1;

  const items: React.JSX.Element[] = [
    <Stack key="basic_application_sent" spacing="sm" mt={3}>
      <H6 data-record>{t('Onboarding.CheckpointBasicApplicationSentStep')}</H6>
      <Body size="lg" mb="xxl" data-record>
        {t('Onboarding.CheckpointBasicApplicationSentStepDescription')}
      </Body>
    </Stack>,
    ...allSteps.map((step) => (
      <StepGroup
        key={step.name}
        stepIsFinished={step.finished}
        stepName={step.name}
      />
    )),
    <Stack key="boosted_application" mt={3}>
      <H6 data-record>{t('Onboarding.CheckpointBoostedApplicationStep')}</H6>
      <Body size="lg" data-record>
        {t('Onboarding.CheckpointBoostedApplicationStepDescription')}
      </Body>
    </Stack>,
  ];

  return (
    <Body size="lg">
      <Container data-testid="checkpoint">
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1;
          const isCompleted = index < completedIndex;

          return (
            <Fragment key={item.key}>
              <IconWrapper>
                <Icon isLastItem={isLastItem} isCompleted={isCompleted} />
                {!isLastItem && <Line $isCompleted={isCompleted} />}
              </IconWrapper>
              <ItemWrapper>{item}</ItemWrapper>
            </Fragment>
          );
        })}
      </Container>
    </Body>
  );
};
